import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { logoutOneSignal, registerOneSignalForLoggedInUser } from '../services/oneSignalPush';

/**
 * After auth is ready, initializes OneSignal (if REACT_APP_ONESIGNAL_APP_ID is set) and
 * POSTs the push subscription id to /auth/save-player-id.
 */
const OneSignalRegister = () => {
  const isAuthenticated = useSelector((s) => s.auth.isAuthenticated);
  const user = useSelector((s) => s.auth.user);
  const permissionsReady = useSelector((s) => s.auth.permissionsReady);
  const prevAuth = useRef(isAuthenticated);

  useEffect(() => {
    if (!isAuthenticated && prevAuth.current) {
      logoutOneSignal();
    }
    prevAuth.current = isAuthenticated;
  }, [isAuthenticated]);

  useEffect(() => {
    if (!isAuthenticated || !user || !permissionsReady) return;

    let cancelled = false;
    (async () => {
      try {
        await registerOneSignalForLoggedInUser(user);
      } catch (e) {
        if (!cancelled) console.warn('OneSignal registration failed:', e?.message || e);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [isAuthenticated, user, permissionsReady]);

  return null;
};

export default OneSignalRegister;
